"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkPalette = void 0;
// Dark-mode counterpart to `palette.ts`'s `lightPalette`. Same brand/status
// colors as light mode; only `background` (and `text`, kept light for
// legibility) differ.
exports.darkPalette = {
    mode: "dark",
    primary: {
        main: "#1E061F",
        light: "#FAF1FA",
        dark: "#2C0A2D",
        contrastText: "#ffffff",
    },
    accent: {
        main: "#7C3F82",
        // light-mode #E4CCE6 is used for borders/tints; muted purple reads as the same on dark bg
        light: "#4A2A4D",
        dark: "#582D5C",
        contrastText: "#ffffff",
    },
    secondary: {
        main: "#C4291F",
        light: "#F6C9C5",
        dark: "#7A1710",
        contrastText: "#ffffff",
    },
    error: {
        main: "#D32F2F",
        light: "#F8D7D5",
        dark: "#9A0007",
        contrastText: "#ffffff",
    },
    warning: {
        main: "#9A6A00",
        light: "#F6E3B4",
        dark: "#6B4900",
        contrastText: "#ffffff",
    },
    info: {
        main: "#b7b7b7",
        light: "#CBE4F3",
        dark: "#0B4361",
        contrastText: "#ffffff",
    },
    success: {
        main: "#16794A",
        light: "#B7E4C7",
        dark: "#0D4E2F",
        contrastText: "#ffffff",
    },
    divider: "#9992A1",
    background: {
        default: "#2B2B2B",
        paper: "#1E1E1E",
    },
    text: {
        primary: "rgba(255, 255, 255, 0.87)",
        secondary: "rgba(255, 255, 255, 0.7)",
        disabled: "rgba(255, 255, 255, 0.5)",
    },
    grey: {
        50: "#212121",
        100: "#292929",
        200: "#333333",
        300: "#424242",
        400: "#616161",
        500: "#757575",
        600: "#9E9E9E",
        700: "#BDBDBD",
        800: "#E0E0E0",
        900: "#F5F5F5",
    },
    action: {
        hover: "rgba(255, 255, 255, 0.08)",
        selected: "rgba(255, 255, 255, 0.16)",
        disabled: "rgba(255, 255, 255, 0.3)",
        disabledBackground: "rgba(255, 255, 255, 0.12)",
        focus: "rgba(255, 255, 255, 0.12)",
    },
};
//# sourceMappingURL=darkPalette.js.map